// SEO-friendly service URLs: /<service-slug>/<id> (buy) and /sell/<service-slug>/<id>.
// The id is what resolves the service; the slug is descriptive only, so a
// renamed service keeps working and gets its URL corrected on load.

export const slugify = (text = '') =>
  text
    .toString()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const SERVICE_BASE_PATH = {
  buy: '/',
  sell: '/sell/start/',
};

export const serviceSlug = (service) => slugify(service.service_name) || 'service';

export const serviceUrl = (service, side = 'buy') => {
  const slug = serviceSlug(service);
  return side === 'sell' ? `/sell/${slug}/${service.id}` : `/${slug}/${service.id}`;
};
